import { render } from "./TagSelect.vue?vue&type=template&id=13e3e69e"
import script from "./TagSelect.vue?vue&type=script&lang=js"
export * from "./TagSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__